function LPPreview() {
    return (
    <section className="py-20 carbon-pattern">
        <div className="max-w-7xl mx-auto px-6">
            <div className="bg-card-dark border border-white/10 rounded-2xl overflow-hidden shadow-2xl flex flex-col md:flex-row">
                <div className="w-full md:w-1/2 p-12">
                    <h2 className="text-3xl font-black text-white italic uppercase mb-6 leading-tight">Professional <br/>Dashboard Interface</h2>

                    <div className="space-y-6">
                        <div className="flex gap-4">
                            <span className="material-symbols-outlined text-primary">data_object</span>

                            <div>
                                <h5 className="text-white font-bold mb-1">Raw Data Export</h5>
                                <p className="text-sm text-slate-400">Export your laps to Motec i2 Pro format for deep dive engineering analysis.</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <span className="material-symbols-outlined text-primary">analytics</span>

                            <div>
                                <h5 className="text-white font-bold mb-1">Lap Comparison</h5>
                                <p className="text-sm text-slate-400">Overlay your laps with team mates or the global community to find time.</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <span className="material-symbols-outlined text-primary">timer</span>

                            <div>
                                <h5 className="text-white font-bold mb-1">Fuel Predictor</h5>
                                <p className="text-sm text-slate-400">Hyper-accurate fuel calculation based on your actual live driving style.</p>
                            </div>
                        </div>
                    </div>
                    <button className="mt-10 bg-primary hover:bg-primary/90 text-white font-bold py-3 px-8 rounded-lg transition-all glow-blue">Explore All Tools</button>
                </div>

                <div className="w-full md:w-1/2 bg-slate-800/20 relative min-h-[400px]">
                    <div className="absolute inset-0 bg-cover bg-center" data-alt="Screenshot of a high-tech racing telemetry dashboard with graphs and charts" style={{backgroundImage: "url('https://lh3.googleusercontent.com/aida-public/AB6AXuCT-xvySraawlzvY3e-j3ygs-dswJLSM7WyUiLza2EzQXsOZ6uN9XswSyzRiN8yL2f3PGmze_bVK47ByqVXUklX9upTr9n9QgfmJaeMxumLMtyYf1F4NBINBLyzJ5ZDvQI0UoxD-yQS3yJbVEx3drPu4XG5_GjSPaAO0kSilsK4wt253gZlcrnt_BUanz_YLNWKNSH1tBM_hPzj6JkAR5zsCUQlMdQ-RwEnto2JyXUcycUEDNsZy2cIqQSFID4kGkRfpE0NpC2OxCU')"}}></div>
                    <div className="absolute inset-0 bg-primary/10 mix-blend-overlay"></div>
                </div>
            </div>
        </div>
    </section>
    );
}

export default LPPreview;